function initCollapsibleTabs(scope = document) {
  const containers = scope.querySelectorAll(".why-loving-it__accordions");
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.collapsibleInit === "1") return;
    container.dataset.collapsibleInit = "1";

    container.addEventListener("click", (e) => {
      const heading = e.target.closest(".collapsible-tab__heading");
      if (!heading || !container.contains(heading)) return;

      const tab = heading.closest(".collapsible-tab");
      if (!tab) return;

      // close others
      container.querySelectorAll(".collapsible-tab.is-open").forEach((el) => {
        if (el !== tab) el.classList.remove("is-open");
      });

      tab.classList.toggle("is-open");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => initCollapsibleTabs());
document.addEventListener("shopify:section:load", (e) => initCollapsibleTabs(e.target));


function initWhyLovingItSlider(scope = document) {
  const section = scope.querySelector('#features') || scope;
  const sliderEl = section.querySelector('.swiper.why-loving-it__slider');
  if (!sliderEl) return;

  // If Swiper isn't loaded yet, retry shortly (your theme lazy-loads it after interaction)
  if (typeof window.Swiper === 'undefined') {
    setTimeout(() => initWhyLovingItSlider(scope), 400);
    return;
  }

  // Prevent double init
  if (sliderEl.swiper) return;

  const swiper = new window.Swiper(sliderEl, {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: true,
    pagination: {
      el: section.querySelector('.why-loving-it__pagination'),
      clickable: true,
    },
    navigation: {
      nextEl: section.querySelector('.swiper-wli-next'),
      prevEl: section.querySelector('.swiper-wli-prev'),
    },
  });

  // When clicking an accordion heading, jump to matching slide
  section.addEventListener('click', (e) => {
    const heading = e.target.closest('.collapsible-tab__heading');
    if (!heading) return;

    const tab = heading.closest('.collapsible-tab');
    if (!tab) return;

    const idx = parseInt(tab.dataset.slide, 10);
    if (!Number.isNaN(idx)) swiper.slideTo(idx);
  });
}

// Init on load + theme editor reloads
document.addEventListener('DOMContentLoaded', () => initWhyLovingItSlider(document));
document.addEventListener('shopify:section:load', (e) => initWhyLovingItSlider(e.target));
